import * as Scrivito from 'scrivito';
import { TrafficInfoWidgetAttributes, TrafficInfoWidgetId } from './traffic-info-widget-definitions';
import { WidgetTitle } from '../../utils/translations';
import { spacingAttributes, spacingContent, spacingGroup } from '../../utils/scrivito/spacing-definitions';

Scrivito.provideEditingConfig(TrafficInfoWidgetId, {
  title: WidgetTitle.TRAFFIC_INFO,
  properties: Object.values(TrafficInfoWidgetAttributes),
  attributes: {
    [TrafficInfoWidgetAttributes.DUMMY_DATA]: {
      title: 'Dummy Daten',
      description: 'Zeige statische Dummy Daten',
    },
    [TrafficInfoWidgetAttributes.DUMMY_AREA_INFO]: {
      title: 'Dummy Großmeldung',
      description: 'Zeige Dummy Großmeldung',
    },
    ...spacingAttributes,
  },
  propertiesGroups: [spacingGroup],
  initialContent: {
    ...spacingContent,
  },
});
